<template lang="pug">
  .clients__item
    v-card(:deleted="!isActiveUser")
      .clients__wrapper
        .clients__info(:class="{'clients__info--deleted': !isActiveUser}")
          h2.card-title.card-title--overflow.cursor-pointer.mb-1(@click="openClient") {{ item.display_name || item.name | shortstr }}
          p.card-text {{ farmsCountLabel(item.farm_count, farmLabels) }}
        .clients__action(
          v-if="isAdmin")
          settings-client-dropdown(
            :id="item.id"
            @edit="showSettings"
            @change="showPass")
          v-dialog(
            max-width="620"
            v-model="modals.showSettingsClient")
            settings-client-modal(
              :item="item"
              @close="modals.showSettingsClient = false")
          v-dialog(
            max-width="320"
            v-model="modals.showChangePasswordClient")
            change-password-client-modal(
              :id="item.id"
              @close="modals.showChangePasswordClient = false")
</template>

<script>
import { mapActions } from 'vuex'

import SettingsClientDropdown from './dropdowns/SettingsClientDropdown'

import ChangePasswordClientModal from './modals/ChangePasswordClientModal'
import SettingsClientModal from './modals/SettingsClientModal'

export default {
  name: 'ClientsItem',

  components: {
    SettingsClientDropdown,
    ChangePasswordClientModal,
    SettingsClientModal
  },

  props: {
    item: {
      type: Object,
      requried: true
    }
  },

  data: () => ({
    modals: {
      showSettingsClient: false,
      showChangePasswordClient: false
    }
  }),

  computed: {
    isActiveUser () {
      return this.item.is_active
    },
    farmLabels () {
      return [this.$t('base.farm'), this.$t('base.farms'), this.$t('base.farms')]
    }
  },

  methods: {
    ...mapActions('dashboard', [
      'getUser'
    ]),

    ...mapActions('account', [
      'setModules'
    ]),

    farmsCountLabel (number, labels) {
      const cases = [2, 0, 1, 1, 1, 2]
      return `${number} ${labels[ (number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5] ]}`
    },
    showSettings () {
      this.modals.showSettingsClient = true
      this.closeAllDropdowns()
    },
    showPass () {
      this.modals.showChangePasswordClient = true
      this.closeAllDropdowns()
    },
    closeAllDropdowns () {
      this.$children.forEach(child => {
        if (child.$refs && child.$refs.dropdown) {
          child.$refs.dropdown.closeDropdown()
        }
      })

      const dropdowns = document.querySelectorAll('.v-dropdown')
      dropdowns.forEach(dropdown => {
        const dropdownInstance = dropdown.__vue__
        if (dropdownInstance && dropdownInstance.closeDropdown) {
          dropdownInstance.closeDropdown()
        }
      })
    },

    async openClient () {
      this.$router.push(`/app/clients/${this.item.id}/companies`)
      this.$emit('openCompany', this.item.id)
      // const data = await this.getUser(this.item.id)
      // if (data) {
      //   this.setModules(data.modules)
      // }
    }
  }
}
</script>
